module.exports = __webpack_public_path__ + "static/media/versace_ground.050c3a4a.jpg";